import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import Login from '@/pages/Login';
import AdminDashboard from '@/pages/Admin/Dashboard';
import SuperAdminDashboard from '@/pages/SuperAdmin/SuperAdminDashboard';
import POSApp from '@/pages/POS/POSAppNew';
import POSDashboard from '@/pages/POS/POSDashboard';
import KitchenApp from '@/pages/Kitchen/KitchenApp';
import RiderApp from '@/pages/Rider/RiderApp';
import KioskApp from '@/pages/Kiosk/KioskApp';
import { Toaster } from '@/components/ui/sonner';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin/*" element={<AdminDashboard />} />
          <Route path="/superadmin" element={<SuperAdminDashboard />} />
          <Route path="/pos" element={<POSApp />} />
          <Route path="/pos-dashboard" element={<POSDashboard />} />
          <Route path="/kitchen" element={<KitchenApp />} />
          <Route path="/rider" element={<RiderApp />} />
          <Route path="/kiosk" element={<KioskApp />} />
        </Routes>
        <Toaster position="top-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;